export default "__VITE_ASSET__BTEzqM99__"